<template>
  <div class="card m-t-6">

    <!--Card image-->
    <div v-if="activity.images">
    <div v-if="activity.images.data.length > 0">
    <img class="img-fluid" :src="activity.images.data[0].thumbnail_path" alt="Card image cap">
    <!--/.Card image-->
    </div>
    </div>

    <!--Card content-->
    <div class="card-block">
        <!--Title-->
        <h4 class="card-title">{{t('Translation not available')}}</h4>
        <!--Text-->
        <p class="card-text">{{t('There\'s not yet an available translation for this activity.')}} <br/>{{t('Change language or search for another activity.')}}</p>
    </div>
    <!--/.Card content-->

  </div>
</template>


<script>
import { mapState } from 'vuex';

export default {
  name: 'ActivityWithoutTranslation',
  components: {
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState({
      language: state => state.language,
      activity: state => state.activityPublic.activity,
    }),

  },
  watch: {

  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// ActivityWithoutTranslation.vue?44e6a84e